import { render, staticRenderFns } from "./CreateTaskDetails.vue?vue&type=template&id=272bc8d2&"
import script from "./CreateTaskDetails.vue?vue&type=script&lang=js&"
export * from "./CreateTaskDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports